import React from "react"
import SbEditable from "storyblok-react"

import Components from "../components/components.js"

import { Slider } from "gatsby-theme-gba"

const SliderEditable = ({ blok }) => (
  <SbEditable content={blok}>
    <Slider>
      {blok.slides &&
        blok.slides.map(innerBlok =>
          React.createElement(Components(innerBlok.component), {
            key: innerBlok._uid,
            blok: {
              ...innerBlok,
              currentLanguage: blok.currentLanguage,
              seoLinks: blok.seoLinks,
            },
          })
        )}
    </Slider>
  </SbEditable>
)

export default SliderEditable
